import React from 'react'

import EditPerformanceData from './EditPerformanceData'; 
function EditPerformanceDataPage() {
    return ( 
        <div className= "container-fluid">
           
            <EditPerformanceData />
        </div>
     );
}

export default EditPerformanceDataPage;